module.exports = __webpack_public_path__ + "img/type3_bg_1.240811bb.png";